module.exports = __webpack_public_path__ + "img/notification_bell.ba78abb0.svg";